import { getObjectValidator } from './validation';

export function generateFieldName(artifactId, itemId) {
    return `artifacts__${artifactId}__${itemId}`;
}

export function getArtifactsValidationSchema(artifacts, raw = false) {
    const validationObject = getObjectValidator();
    const schema = {};

    artifacts.forEach((artifact, artifactIndex) => {
        artifact.forEach((artifactItem, artifactItemIndex) => {
            const item = { ...artifactItem };
            const addValidationCriteria = criteria => {
                schema[
                    generateFieldName(artifactIndex, artifactItemIndex)
                ] = criteria;
            };

            switch (item.dataType) {
                case 'String': {
                    const criteria = validationObject
                        .string('Not a string')
                        .required(item.fullName + ' is a required field');
                    if (item.valueLength) criteria.max(item.valueLength);
                    addValidationCriteria(criteria);
                    break;
                }
                case 'IPv4 address':
                    addValidationCriteria(
                        validationObject
                            .string('Not a string')
                            .ipv4('Not an IPv4 address')
                            .required(item.fullName + ' is a required field')
                    );
                    break;

                case 'IPv6 address':
                    addValidationCriteria(
                        validationObject
                            .string('Not a string')
                            .ipv6('Not an IPv6 address')
                            .required(item.fullName + ' is a required field')
                    );
                    break;

                case 'Floating point':
                    addValidationCriteria(
                        validationObject
                            .number()
                            .typeError('Not a number')
                            .floatingPoint('Not a floating number')
                    );
                    break;

                case 'Integer':
                case 'Long': {
                    const criteria = validationObject
                        .number()
                        .typeError('Not a number')
                        .integer('Not an integer')
                        .required(item.fullName + ' is a required field');
                    if (item.valueLength) criteria.max(item.valueLength);
                    addValidationCriteria(criteria);
                    break;
                }
                case 'Timestamp':
                    addValidationCriteria(
                        validationObject
                            .date('Not a date')
                            .required(item.fullName + ' is a required field')
                    );
                    break;

                case 'MAC address':
                    addValidationCriteria(
                        validationObject
                            .string('Not a string')
                            .macAddress('Not a MAC Address')
                            .required(item.fullName + ' is a required field')
                    );
                    break;
            }
        });
    });

    if (raw) return schema;
    return validationObject.object().shape(schema);
}
